import { pageShim } from '@/components/PageHeader/PageHeader.css';
import Shim, { ShimProps } from '../Shim';

type PageShimProps = ShimProps;

export default function PageShim({ ...props }: PageShimProps) {
  return <Shim {...props} className={`${pageShim} ${props.className}`} />;
}
